import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.HANGRY_GOBLINS;

export const LEVEL_COUNT = 10;
export const GOBLINS_PER_LEVEL = 15;
export const MASTERY_THRESHOLD = 0.86;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  ONBOARDING_VIEW: 'ONBOARDING_VIEW',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SAVE_SCREEN_COORDINATES: 'SAVE_SCREEN_COORDINATES',
  LOAD_CURRICULUM: 'LOAD_CURRICULUM',
  SET_BACKGROUNDS: 'SET_BACKGROUNDS',
  INCREASE_PROGRESS: 'INCREASE_PROGRESS',
  START_ROUND: 'START_ROUND',
  COMPLETE_ROUND: 'COMPLETE_ROUND',
  INCREMENT_CORRECT_COUNT: 'INCREMENT_CORRECT_COUNT',
  MARK_ONBOARDING_SEEN: 'MARK_ONBOARDING_SEEN',
  MARK_PRACTICE_ONBOARDING_SEEN: 'MARK_PRACTICE_ONBOARDING_SEEN',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const FRAMES = {
  green: {
    idle: [0, 82],
    spitting: [82, 126],
    barfing: [126, 165],
    eating: [165, 227],
  },
  darkGreen: {
    idle: [244, 309],
    spitting: [310, 354],
    barfing: [354, 392],
  },
  red: {
    idle: [425, 490],
    spitting: [491, 535],
    barfing: [536, 573],
  },
  hangry: {
    idle: [606, 671],
    spitting: [672, 716],
    barfing: [717, 754],
  },
  transitions: {
    greenToDarkGreen: [228, 244],
    darkGreenToGreen: [393, 408],
    darkGreenToRed: [409, 425],
    redToGreen: [574, 589],
    redToHangry: [590, 606],
    hangryToGreen: [755, 770],
  },
};

export const TRANSITION_TIME_IN_SECONDS = 450;

export const BACKGROUNDS = ['HangryBg1', 'HangryBg2', 'HangryBg3', 'HangryBg4', 'HangryBg5', 'HangryBg6'];

export const GOBLIN_POSITIONS = [[250, 220], [450, 170], [650, 220]];
